import { Component, Output, EventEmitter } from '@angular/core';
import { ApiTermsConditionService } from '../../services/api-terms-conditions';
import { UserState } from 'src/app/state/user/user.state';
import { Store } from '@ngxs/store';
import { UserActions } from 'src/app/state/user/user.actions';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-license-terms-condition-modal',
  templateUrl: './license-terms-condition-modal.component.html',
  styleUrl: './license-terms-condition-modal.component.scss'
})
export class LicenseTermsConditionModalComponent {

  isScrolledToBottom = false; // track if user reached bottom
  isTermsConditionAccepted: boolean = false;
  @Output() scrolledToBottom = new EventEmitter();
  @Output() isModalClosed = new EventEmitter<boolean>();
  constructor(
    private readonly apiTermsConditionService: ApiTermsConditionService,
    private readonly store: Store,
    private readonly dialogRef: DynamicDialogRef,
    private readonly messageService: MessageService
  ) { }

  onAcceptTermsCondition() {
    this.isTermsConditionAccepted = true;
    //patch method 'api/license/accept-terms' to set hasTermsAccepted to true in userLicenseAccess state
    //LicenseNumber, UserEmail
    this.store.dispatch(new UserActions.GetLicenseAccess()).subscribe(() => {
      const loggedInUserDetails: any = {
        userEmail: this.store.selectSnapshot(UserState.userProfile)?.email,
        licenseNumber: this.store.selectSnapshot(UserState.userLicenseAccess)?.licenseNumber
      };
      this.apiTermsConditionService.saveTermsCondition(loggedInUserDetails).subscribe({
        next: (response) => {
          this.isModalClosed.emit(true);
          this.dialogRef.close(true);
        },
        error: (error) => {
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'We’re having trouble processing your request right now. Please try again in a few minutes.', key: 'tl', life: 3000 });
        }
      });
    });
  }

  onScroll(event: any): void {
    const element = event?.target;
    const atBottom = element?.scrollHeight - element?.scrollTop <= element?.clientHeight * 1.01;
    this.isScrolledToBottom = atBottom; // update boolean
    if (atBottom) {
      this.scrolledToBottom.emit();
    }
  }
}
